class FabricTooltipMessage extends HTMLElement {
  constructor() {
    super();
    this.initializeElements();
    this.addEventListeners();
  }

  initializeElements() {
    this.fabricRadios = document.querySelectorAll(".fabric-radios input");
    this.selected = String(
      [...this.fabricRadios].find((radio) => radio.checked).value.toLowerCase(),
    );
    const tooltip = document.querySelector(
      `[data-fabric-id="${this.selected}"]`,
    );
    this.selectedTooltip = tooltip;
    this.fabric = tooltip?.dataset?.fabricId;
    this.toggleMessage();
  }

  addEventListeners() {
    this.fabricRadios.forEach((radio) => {
      radio.addEventListener("click", () => {
        if (radio.checked) {
          this.selected = String(radio.value.toLowerCase());
          this.toggleMessage();
        }
      });
    });
  }

  toggleMessage() {
    if (this.fabric !== this.selected) {
      this.selectedTooltip.classList.add("hidden");
      this.selectedTooltip.classList.remove("block");
    } else {
      this.selectedTooltip.classList.remove("hidden");
      this.selectedTooltip.classList.add("block");
    }
  }
}

customElements.define("fabric-tooltip-message", FabricTooltipMessage);
